import type { ProgressSubchapterStatus } from "@/api/generated/model";

export enum LessonStatus {
  Completed = "completed",
  InProgress = "in_progress",
  NotStarted = "not_started",
}

const LESSON_STATUS_BY_API: Record<ProgressSubchapterStatus, LessonStatus> = {
  completed: LessonStatus.Completed,
  in_progress: LessonStatus.InProgress,
  not_started: LessonStatus.NotStarted,
};

/** The status the API reports for a subchapter, as the tree understands it. */
export const lessonStatusFromApi = (
  status: ProgressSubchapterStatus
): LessonStatus => LESSON_STATUS_BY_API[status];

export interface AggregatedProgress {
  progressPercent: number;
  totalLessons: number;
  completedLessons: number;
  totalChapters: number;
}
